export const selectTemplateReducer = (state, action) => {
  state.selectedTemplate = action.payload;
};

export const toggleLoadingDocumentReducer = (state, action) => {
  state.loadingDocument = action.payload;
};

export const toggleSavingArtworkReducer = (state, action) => {
  const { value, type } = action.payload;

  switch (type) {
    case 'save':
      state.saveDocumentLoading = value;
      break;
    case 'export':
      state.exportDocumentLoading = value;
      break;
    case 'download':
      state.downloadingArtwork = value;
      break;
    default:
      null;
  }
};
